import { createContext, FunctionComponent, PropsWithChildren, useContext } from 'react';

interface UrlContext {
  url: URL;
  childPath?: string;
}

export const UrlContext = createContext<UrlContext | undefined>(undefined);

export const useUrlContext = (): UrlContext => {
  const context = useContext(UrlContext);
  if (context === undefined) {
    throw new Error('useUrlContext must be used within a UrlContext.Provider');
  }
  return context;
};

interface UrlContextProvider {
  url: URL;
  childPath?: string;
}

export const UrlContextProvider: FunctionComponent<PropsWithChildren<UrlContextProvider>> = ({
  children,
  url,
  childPath,
}) => {
  return <UrlContext.Provider value={{ url, childPath }}>{children}</UrlContext.Provider>;
};
